module.exports = __webpack_public_path__ + "img/DSC_0098.f466e61c.jpg";